import * as React from "react";
import { Table, TableBody } from "@material-ui/core";
import ArticlesDetailsRow from "./ArticlesDetailsRow";
import { ApiOrderItem } from "lib/api";

interface Props {
  items: ApiOrderItem[];
}

const ArticlesDetails: React.FunctionComponent<Props> = ({ items }) => {
  return (
    <Table size="small">
      <TableBody>
        {items.map(i => (
          <ArticlesDetailsRow key={i.ref} item={i} />
        ))}
      </TableBody>
    </Table>
  );
};

export default ArticlesDetails;
